import { message as staticMessage } from 'antd'
import type { MessageInstance } from 'antd/es/message/interface'
import { createElement } from 'react'

/**
 * toast 门面:API 与历史自研实现一致(success/error/info/warning + 可选 duration 毫秒),
 * 内核为 antd 原生 message —— 主题继承 ConfigProvider(经 App.tsx 内 MessageBridge 注入
 * 的上下文实例);应用启动前的调用 fallback 到 antd 静态实例。
 */

export type ToastType = 'success' | 'error' | 'info' | 'warning'

const DEFAULT_DURATION_MS: Record<ToastType, number> = {
  success: 3000,
  info: 3000,
  warning: 4000,
  error: 5000,
}

let instance: MessageInstance | null = null

/** 由 MessageBridge(App.useApp().message)注入上下文实例 */
export function setToastInstance(inst: MessageInstance): void {
  instance = inst
}

function getInstance(): MessageInstance {
  return instance ?? staticMessage
}

function show(type: ToastType, content: string, durationMs?: number): void {
  const ms = durationMs ?? DEFAULT_DURATION_MS[type]
  // antd duration 单位为秒;<=0 表示不自动关闭(与历史实现同语义)
  const sec = ms <= 0 ? 0 : ms / 1000
  // 部分错误消息含换行,保留原 Toaster 的 pre-wrap 渲染
  getInstance().open({
    type,
    content: createElement('span', { className: 'whitespace-pre-wrap break-words' }, content),
    duration: sec,
  })
}

export const toast = {
  success(message: string, duration?: number): void {
    show('success', message, duration)
  },
  error(message: string, duration?: number): void {
    show('error', message, duration)
  },
  info(message: string, duration?: number): void {
    show('info', message, duration)
  },
  warning(message: string, duration?: number): void {
    show('warning', message, duration)
  },
}
